import script from "./QuotesTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotesTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./QuotesTemplate.vue?vue&type=style&index=0&id=b3471712&lang=css"

const __exports__ = script;

export default __exports__